import React, { useEffect, useState, useMemo } from "react"
import UpdateOrderCard from "../../components/UpdateOrderCard"
import LoadingSpinner from "../../components/LoadingSpinner"
import UpdateConfirm from "../../components/UpdateConfirm"
import UpdateCancelConfirm from "../../components/UpdateCancelConfrim"
import moment from "moment-timezone"

// Set default timezone
moment.tz.setDefault("America/New_York")

const OrderUpdate = ({ handleSetView, orderRef }) => {
  // const shop = window.location.ancestorOrigins[0].replace("https://", "");
  const urlParams = new URLSearchParams(window.location.search)
  const shop = urlParams.get("store")
  const [order, setOrder] = useState()
  const [quantity, setQuantity] = useState(1)
  const [originalQty, setOriginalQty] = useState()
  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState("")
  const [view, setView] = useState("orders")
  const [selectedEvent, setSelectedEvent] = useState()
  const [canCancel, setCanCancel] = useState(true)
  const [canModify, setCanModify] = useState(true)
  const currentTime = moment().format()

  useMemo(() => {
    ;(async function () {
      setLoading(true)
      handleSetView("order")
      try {
        const response = await fetch(
          `${process.env.REACT_APP_SERVER}/order/${orderRef}`
        )
        const order = await response.json()
        const date = moment(order.data.order.date).format("YYYY-MM-DD")
        const startTime = moment(order.data.order.start_time).format("HH:MM:00")
        const orderDate = moment(`${date} ${startTime}`).format()

        setCanModify(!moment(currentTime).isAfter(moment(orderDate)))

        setCanCancel(
          !moment(currentTime).isAfter(moment(orderDate).subtract(48, "hours"))
        )
        setOrder(order.data.order)
        setOriginalQty(order.data.order.quantity)
        setQuantity(order.data.order.quantity)
        setLoading(false)
      } catch (error) {
        console.log(error)
      }
    })()
  }, [])

  const handleUpdate = async () => {
    let event = {}
    if (selectedEvent.appointment_id) {
      // Handle if appointment date/time was not changed
      event = { ...selectedEvent, quantity }
    } else {
      // Handle if appointment date/time was changed
      const date = moment(selectedEvent.start)
      const start_time = selectedEvent.start
      const end_time = selectedEvent.end
      const { order_id } = order

      event = { date, start_time, end_time, order_id, quantity }
    }

    if (event && event.start_time !== undefined) {
      setLoading(true)
      // const { start, end } = selectedEvent
      // const { variantId, quantity } = view.selectedAppointment

      // const cartId = variantId.replace('gid://shopify/ProductVariant/', '')
      // console.log(cartId)
      // const {order_id, quantity, spots, start_time, end_time, date} = selectedEvent

      // if (quantity > spots) {
      //   console.log("Not enough spots available.")
      //   return
      // }

      const response = await fetch(
        `${process.env.REACT_APP_SERVER}/order?shop=${shop}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ...event, orderRef }),
        }
      )
      const update = await response.json()

      setLoading(false)
      if (response.status !== 200) {
        setStatus(`An error occured while updating the appointment.`)
      }
      setOrder((order) => ({
        ...order,
        date: event.date,
        start_time: event.start_time,
      }))
      setStatus(
        `Your appointment for ${update.data.appointment.title} has been successfully updated.`
      )
      handleChangeView("orders")
    } else {
      console.log("No event selected")
    }
  }

  const handleCancel = () => {
    if (canCancel) {
      setView("cancelConfirm")
    }
  }

  const confirmCancel = () => {
    ;(async () => {
      setLoading(true)
      const response = await fetch(
        `${process.env.REACT_APP_SERVER}/order?shop=${shop}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ orderRef }),
        }
      )
      const cancelRequest = await response.json()
      if (response.status === 200) {
        setStatus(`${cancelRequest.data.appointment.title} has been cancelled.`)
        setOrder((order) => ({ ...order, cancelled: true }))
      } else {
        setStatus(`An error occured while cancelling appointment.`)
      }
      handleChangeView("orders")
      setLoading(false)
    })()
  }

  const handleChangeView = (view) => {
    setView(view)
  }

  return (
    <>
      <div className="ct-modal__body">
        {view === "orders" && (
          <>
            {status && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 16,
                }}
              >
                <span
                  style={{
                    fontSize: "20px",
                    color: "#fd6a4f",
                    fontWeight: 700,
                  }}
                >
                  {status}
                </span>
              </div>
            )}
            {!loading && order.order_id && (!canCancel || !canModify) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    marginBottom: 12,
                    color: "#fd6a4f",
                    fontWeight: 700,
                  }}
                >
                  {canModify
                    ? `You cannot cancel your workshop order or remove quanity 48 hours
                  before the workshop starts.`
                    : `You cannot modify a workshop order after the workshop started.`}
                </span>
              </div>
            )}
            {!loading && order.order_id && (
              <UpdateOrderCard
                orderRef={orderRef}
                order={order}
                quantity={quantity}
                handleCancel={handleCancel}
                handleChangeView={handleChangeView}
                canCancel={canCancel}
                canModify={canModify}
                status={status}
              />
            )}
            {!loading && !order.order_id && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "20px",
                    color: "#fd6a4f",
                    fontWeight: 700,
                  }}
                >
                  Cannot find appointment.
                </span>
              </div>
            )}
            {loading && <LoadingSpinner />}
          </>
        )}
        {view === "cancelConfirm" && (
          <>
            {!loading && order.order_id && (
              <UpdateCancelConfirm
                orderRef={orderRef}
                order={order}
                handleChangeView={handleChangeView}
                confirmCancel={confirmCancel}
              />
            )}
          </>
        )}
        {view === "reschedule" && (
          <>
            {!loading && (
              <UpdateConfirm
                appointment={order}
                handleChangeView={handleChangeView}
                setSelectedEvent={setSelectedEvent}
                selectedEvent={selectedEvent}
                setQuantity={setQuantity}
                quantity={quantity}
                originalQty={originalQty}
                canCancel={canCancel}
              />
            )}
            {loading && <LoadingSpinner />}
          </>
        )}
      </div>
      {view === "reschedule" && (
        <div className="ct-modal__confirm-actions">
          <button
            className="ct-modal__button"
            onClick={() => handleChangeView("orders")}
          >
            Back
          </button>
          <button
            className="ct-modal__button"
            style={{ marginLeft: "25px" }}
            onClick={() => handleUpdate()}
          >
            Update
          </button>
        </div>
      )}
    </>
  )
}

export default OrderUpdate
